import { useState, useEffect, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "components/Context/AuthContext";
import AuthenticatedProfile from "components/MyProfile/AuthenticatedProfile";
import UnauthenticatedProfile from "components/MyProfile/UnauthenticatedProfile";

const Navbar = () => {
    const { isAuthenticated, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [profileOpen, setProfileOpen] = useState(false);
    const profileRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (profileRef.current && !profileRef.current.contains(e.target)) {
                setProfileOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleLogout = (e) => {
        e.preventDefault();
        logout();
        navigate("/home");
    };

    return (
        <header className="flex items-center justify-between px-[22px] py-[18px] bg-black-900">
            <Link to="/home">
                <img
                    src={`${process.env.PUBLIC_URL}/images/logo_white.svg`}
                    alt="TRG Logo"
                    className="h-[40px] object-contain"
                />
            </Link>

            <div className="flex items-center gap-6">
                {isAuthenticated ? (
                    <>
                        <div className="relative" ref={profileRef}>
                            <button
                                onClick={() => setProfileOpen((prev) => !prev)}
                                className="text-[16px] font-medium text-gray-300 hover:underline"
                            >
                                Profile
                            </button>
                            {profileOpen && (
                                <AuthenticatedProfile showLogout={false} />
                            )}
                        </div>
                        <button
                            onClick={handleLogout}
                            className="text-[16px] font-medium text-gray-300 hover:underline"
                        >
                            Logout
                        </button>
                    </>
                ) : (
                    <div className="relative" ref={profileRef}>
                        <button
                            onClick={() => setProfileOpen((prev) => !prev)}
                            className="text-[16px] font-medium text-gray-300 hover:underline"
                        >
                            Login
                        </button>
                        {profileOpen && <UnauthenticatedProfile />}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Navbar;
